
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC","d":"M24 16H12v21h17V21h-5z"}}),_c('path',{staticClass:"i-Rectangle 5",attrs:{"stroke":"#234652","stroke-dasharray":"2 3","stroke-miterlimit":"16","d":"M32 15.706V5H9v29h3.503"}}),_c('path',{staticClass:"i-Rectangle 6",attrs:{"stroke":"#234652","stroke-dasharray":"2 3","d":"M29.144 13H38v29H15v-5.582"}}),_c('path',{staticClass:"i-Rectangle 7",attrs:{"stroke":"#234652","d":"M15 34h17V18.5L26.5 13H15z"}}),_c('path',{staticClass:"i-Rectangle 9",attrs:{"stroke":"#234652","d":"M26 13v6h6"}})])
          )
        }
      }
    